import type { RouteObject } from "react-router-dom";
import { addSlashes } from "../route.utils";
import { Spinner } from "@/components/ui/v2/spinner";
import { ChatPage } from "@/pages/(home)/(my-space)/chat";

export const DYNAMIC_CONVERSATION_ID_KEY = "conversationId";

export enum MS_CHAT_PATH_SEGMENTS {
  ROOT = "chat",
  CONVERSATION = `:${DYNAMIC_CONVERSATION_ID_KEY}`,
}

export const myspaceChatRoutes: RouteObject = {
  path: MS_CHAT_PATH_SEGMENTS.ROOT,
  HydrateFallback: Spinner,
  // Full-bleed: the two panes own their own scrolling.
  handle: { breadcrumb: "Chat", flushContent: true },
  children: [
    { index: true, Component: ChatPage },
    { path: MS_CHAT_PATH_SEGMENTS.CONVERSATION, Component: ChatPage },
  ],
};

export const MS_CHAT_PATHS = Object.freeze({
  ROOT: addSlashes(MS_CHAT_PATH_SEGMENTS.ROOT),
  CONVERSATION: (id: number) => addSlashes(MS_CHAT_PATH_SEGMENTS.ROOT, String(id)),
});
